import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Container } from '@hvcgroep/design-system';
import { Helmet } from 'react-helmet';

import './style.scss';


const ErrorPage: React.FC<{ type?: 'notFound' | 'serverError' }> = ({ type = 'notFound' }) => {
  const { t } = useTranslation();

  const siteTitle = t('general.siteTitle');
  const notFound = {
    heading: t('pages.notFound.title'),
    subTitle: t('pages.notFound.subTitle'),
    button: { label: t('pages.notFound.button.title'), link: t('pages.notFound.button.link') },
  };
  const serverError = {
    heading: t('pages.serverError.title'),
    subTitle: t('pages.serverError.subTitle'),
    button: { label: t('pages.serverError.button.title'), link: t('pages.serverError.button.link') },
  };

  const errorContent = type === 'notFound' ? notFound : serverError;

  return (
    <Container fluid>
      <Helmet><title>{`${errorContent.heading} - ${siteTitle}`}</title></Helmet>
      <h1>{errorContent.heading}</h1>
      <p className="NotFound__subtititle">{errorContent.subTitle}</p>

      <Button href={errorContent.button.link}>{errorContent.button.label}</Button>

    </Container>
  );
};

export default ErrorPage;
